var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-change-num comp"},[_c('div',{staticClass:"con"},[_c('set-pwd',{attrs:{"pwd-con":_vm.pwdSet},on:{"pwd-get":_vm.pwdOk}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }